import { ColorPalette } from '../types';

// taken from https://github.mlbam.net/Product-Design/design-tokens/blob/main/tokens/core/color.json
export const colors: { color: ColorPalette } = {
  color: {
    white: {
      value: '#ffffff',
      type: 'color',
    },
    black: {
      value: '#000000',
      type: 'color',
    },
    neutral: {
      neutral100: {
        value: '#f4f5f6',
        type: 'color',
      },
      neutral200: {
        value: '#e8eaed',
        type: 'color',
      },
      neutral300: {
        value: '#dbdfe3',
        type: 'color',
      },
      neutral400: {
        value: '#c3c8cf',
        type: 'color',
      },
      neutral500: {
        value: '#acb3bc',
        type: 'color',
      },
      neutral600: {
        value: '#959da8',
        type: 'color',
      },
      neutral700: {
        value: '#7f8994',
        type: 'color',
      },
      neutral800: {
        value: '#6a7480',
        type: 'color',
      },
      neutral900: {
        value: '#57606c',
        type: 'color',
      },
      neutral1000: {
        value: '#444d58',
        type: 'color',
      },
      neutral1100: {
        value: '#333b44',
        type: 'color',
      },
      neutral1200: {
        value: '#232931',
        type: 'color',
      },
      neutral1300: {
        value: '#14191f',
        type: 'color',
      },
      neutral1400: {
        value: '#070a0d',
        type: 'color',
      },
    },
    yellow: {
      yellow100: {
        value: '#f7e0c8',
        type: 'color',
        description: 'Shade color with 92% of lightness',
      },
      yellow200: {
        value: '#edc394',
        type: 'color',
        description: 'Shade color with 84.2% of lightness',
      },
      yellow300: {
        value: '#e0a561',
        type: 'color',
        description: 'Shade color with 76.4% of lightness',
      },
      yellow400: {
        value: '#d08929',
        type: 'color',
        description: 'Shade color with 68.7% of lightness',
      },
      yellow500: {
        value: '#bd6d00',
        type: 'color',
        description: 'Shade color with 60.9% of lightness',
      },
      yellow600: {
        value: '#a65400',
        type: 'color',
        description: 'Shade color with 53.1% of lightness',
      },
      yellow700: {
        value: '#8c3c00',
        type: 'color',
        description: 'Shade color with 45.3% of lightness',
      },
      yellow800: {
        value: '#712800',
        type: 'color',
        description: 'Shade color with 37.6% of lightness',
      },
      yellow900: {
        value: '#541700',
        type: 'color',
        description: 'Shade color with 29.8% of lightness',
      },
      yellow1000: {
        value: '#370900',
        type: 'color',
        description: 'Shade color with 22% of lightness',
      },
    },
    green: {
      green100: {
        value: '#d4edd3',
        type: 'color',
        description: 'Shade color with 92% of lightness',
      },
      green200: {
        value: '#acdaa9',
        type: 'color',
        description: 'Shade color with 84.2% of lightness',
      },
      green300: {
        value: '#84c681',
        type: 'color',
        description: 'Shade color with 76.4% of lightness',
      },
      green400: {
        value: '#5eb15c',
        type: 'color',
        description: 'Shade color with 68.7% of lightness',
      },
      green500: {
        value: '#399a39',
        type: 'color',
        description: 'Shade color with 60.9% of lightness',
      },
      green600: {
        value: '#098314',
        type: 'color',
        description: 'Shade color with 53.1% of lightness',
      },
      green700: {
        value: '#006c00',
        type: 'color',
        description: 'Shade color with 45.3% of lightness',
      },
      green800: {
        value: '#005400',
        type: 'color',
        description: 'Shade color with 37.6% of lightness',
      },
      green900: {
        value: '#003c00',
        type: 'color',
        description: 'Shade color with 29.8% of lightness',
      },
      green1000: {
        value: '#002500',
        type: 'color',
        description: 'Shade color with 22% of lightness',
      },
    },
    red: {
      red100: {
        value: '#ffd8d4',
        type: 'color',
        description: 'Shade color with 92% of lightness',
      },
      red200: {
        value: '#ffb3ad',
        type: 'color',
        description: 'Shade color with 84.2% of lightness',
      },
      red300: {
        value: '#fd8d87',
        type: 'color',
        description: 'Shade color with 76.4% of lightness',
      },
      red400: {
        value: '#f16966',
        type: 'color',
        description: 'Shade color with 68.7% of lightness',
      },
      red500: {
        value: '#de4447',
        type: 'color',
        description: 'Shade color with 60.9% of lightness',
      },
      red600: {
        value: '#c61b2b',
        type: 'color',
        description: 'Shade color with 53.1% of lightness',
      },
      red700: {
        value: '#aa0013',
        type: 'color',
        description: 'Shade color with 45.3% of lightness',
      },
      red800: {
        value: '#8a0000',
        type: 'color',
        description: 'Shade color with 37.6% of lightness',
      },
      red900: {
        value: '#680000',
        type: 'color',
        description: 'Shade color with 29.8% of lightness',
      },
      red1000: {
        value: '#450000',
        type: 'color',
        description: 'Shade color with 22% of lightness',
      },
    },
    blue: {
      blue100: {
        value: '#d0e6ff',
        type: 'color',
        description: 'Shade color with 92% of lightness',
      },
      blue200: {
        value: '#a4cdff',
        type: 'color',
        description: 'Shade color with 84.2% of lightness',
      },
      blue300: {
        value: '#7ab2ff',
        type: 'color',
        description: 'Shade color with 76.4% of lightness',
      },
      blue400: {
        value: '#5298ff',
        type: 'color',
        description: 'Shade color with 68.7% of lightness',
      },
      blue500: {
        value: '#2c7df8',
        type: 'color',
        description: 'Shade color with 60.9% of lightness',
      },
      blue600: {
        value: '#0062e3',
        type: 'color',
        description: 'Shade color with 53.1% of lightness',
      },
      blue700: {
        value: '#0048c7',
        type: 'color',
        description: 'Shade color with 45.3% of lightness',
      },
      blue800: {
        value: '#0031a6',
        type: 'color',
        description: 'Shade color with 37.6% of lightness',
      },
      blue900: {
        value: '#001d80',
        type: 'color',
        description: 'Shade color with 29.8% of lightness',
      },
      blue1000: {
        value: '#000c57',
        type: 'color',
        description: 'Shade color with 22% of lightness',
      },
    },
    purple: {
      purple100: {
        value: '#e7e0fa',
        type: 'color',
        description: 'Shade color with 92% of lightness',
      },
      purple200: {
        value: '#d0c2f3',
        type: 'color',
        description: 'Shade color with 84.2% of lightness',
      },
      purple300: {
        value: '#b9a5e9',
        type: 'color',
        description: 'Shade color with 76.4% of lightness',
      },
      purple400: {
        value: '#a38adb',
        type: 'color',
        description: 'Shade color with 68.7% of lightness',
      },
      purple500: {
        value: '#8d6fc9',
        type: 'color',
        description: 'Shade color with 60.9% of lightness',
      },
      purple600: {
        value: '#7756b3',
        type: 'color',
        description: 'Shade color with 53.1% of lightness',
      },
      purple700: {
        value: '#613f99',
        type: 'color',
        description: 'Shade color with 45.3% of lightness',
      },
      purple800: {
        value: '#4b2b7d',
        type: 'color',
        description: 'Shade color with 37.6% of lightness',
      },
      purple900: {
        value: '#361a5e',
        type: 'color',
        description: 'Shade color with 29.8% of lightness',
      },
      purple1000: {
        value: '#210b3e',
        type: 'color',
        description: 'Shade color with 22% of lightness',
      },
    },
  },
};
